<template>
  <el-row type="flex" justify="center">
    <el-form :model="bonusVersionList" :rules="rules" label-width="80px" ref="createConfigRef">
      <el-form-item label="年份" prop="year">
        <el-date-picker v-model="bonusVersionList.year" type="year" @change="changeYear" value-format="yyyy" placeholder="请选择年份">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="渠道" prop="channel">
        <el-select v-model="bonusVersionList.channel" @change="changeChannel" @focus="focusChannel" placeholder="请选择渠道">
          <el-option :label="item.label" :value="item.value + '^' + item.label" v-for="(item, index) in channelList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位" prop="position">
        <el-select v-model="bonusVersionList.position" @change="changePosition" @focus="focusPosition" placeholder="请选择职位">
          <el-option :label="item.label" :value="item.value + '^' + item.label" v-for="(item, index) in positionList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="KPI">
        <el-card shadow="never">
          <!-- Q1-Q4选择门槛和季度 yearly选择年度 -->
          <el-row type="flex" justify="space-between" :span="6" v-for="(item, index) in ['Q1', 'Q2', 'Q3', 'Q4' ,'Yearly']" :key="index">
            <div style="width:40px">{{item}}</div>
            <el-button type="primary" v-if="item === 'Yearly'" @click="chooseKpi('C'+index, '年度考核', bonusVersionList.channel, bonusVersionList.year)">请选择</el-button>
            <el-button type="primary" v-else @click="chooseKpi('C'+index, '季度考核', bonusVersionList.channel, bonusVersionList.year)">请选择</el-button>
            <div>附加</div>
            <el-button type="primary" @click="chooseKpi('A'+index, '附加', bonusVersionList.channel, bonusVersionList.year)">请选择</el-button>
          </el-row>
        </el-card>
      </el-form-item>
    </el-form>
    <choose-kpi ref="chooseKpiRef" />
  </el-row>
</template>
<script>
import chooseKpi from './chooseKpi.vue'

export default {
  name: 'createConfig',
  components: { chooseKpi },
  data () {
    return {
      bonusVersionList: {
        year: null,
        channel: null,
        position: null
      },
      channelList: [],
      // channelListFilter: [],
      positionList: [],
      rules: {
        year: [{ required: true, message: '请选择年份', trigger: 'blur' }],
        channel: [{ required: true, message: '请选择渠道', trigger: 'change' }],
        position: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      isBack: false
    }
  },
  created () {},
  mounted () {
    this.getChannelList()
  },
  methods: {
    // 获取渠道列表
    getChannelList () {
      this.channelList = []
      this.$http.get(this.API.channelList).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          let channelList = []
          let arr = data.data
          if (arr.length > 0 && arr !== '' && arr !== null) {
            arr.forEach(ele => {
              channelList.push({
                value: ele.id,
                label: ele.name
              })
            })
          }
          this.channelList = channelList
          // 返回判断channel加ID
          if (this.bonusVersionList.channel !== null && this.bonusVersionList.channel.indexOf('^') === -1) {
            let selectedChannelList = channelList.filter(ele => {
              return ele.label === this.bonusVersionList.channel
            })
            let channelId = selectedChannelList[0].value
            this.channelFilterPosition(channelId)
            this.bonusVersionList.channel = channelId + '^' + this.bonusVersionList.channel
          }
          // console.log(this.bonusVersionList)
        } else {
          this.channelList = []
          this.$message.error('接口调用失败！')
        }
        // console.log(this.channelList)
      })
    },
    // 渠道筛选对应渠道职位
    channelFilterPosition (selectedChannelId) {
      this.positionList = []
      if (selectedChannelId === '') {
        this.$message.error('请选择渠道！')
      } else {
        this.$http.get(this.API.positionListByChannelId, { params: { channelId: selectedChannelId } }).then(res => {
          // console.log(res)
          let data = res.data
          if (data.code === 200 && data.data.length > 0) {
            let positionList = []
            let arr = data.data
            if (arr.length > 0 && arr !== '' && arr !== null) {
              arr.forEach(ele => {
                positionList.push({
                  value: ele.id,
                  label: ele.name
                })
              })
            }
            this.positionList = positionList
            // 返回判断position加ID
            if (this.bonusVersionList.position !== null && this.bonusVersionList.position.indexOf('^') === -1) {
              // console.log(positionList)
              let selectedPositionList = positionList.filter(ele => {
                return ele.label === this.bonusVersionList.position
              })
              // console.log(selectedPositionList)
              let positionId = selectedPositionList[0].value
              this.bonusVersionList.position = positionId + '^' + this.bonusVersionList.position
            }
          } else if (data.data.length === 0 || data.data === null) {
            this.$message.warning('暂无数据！')
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      }
    },
    // 打开选择KPI-下标和类型区分
    chooseKpi (index, type, channelId, year) {
      if (this.bonusVersionList.year !== null && this.bonusVersionList.channel !== null && this.bonusVersionList.position !== null) {
        let bonusVersionList = {}
        bonusVersionList.year = this.bonusVersionList.year
        bonusVersionList.channelId = this.bonusVersionList.channel.split('^')[0]
        bonusVersionList.positionId = this.bonusVersionList.position.split('^')[0]
        if (this.isBack) {
          this.getKpiList(bonusVersionList)
        }
        channelId = channelId.split('^')[0]
        this.$refs.createConfigRef.validate((valid) => {
          if (valid) {
            this.$refs.chooseKpiRef.add(index, type, channelId, year)
          } else {
            return false
          }
        })
      } else {
        this.$message.warning('年份、渠道、职位为必选！')
      }
    },
    // year事件
    changeYear () {
      if (
        this.bonusVersionList.year !== null &&
        this.bonusVersionList.channel !== null &&
        this.bonusVersionList.position !== null
      ) {
        let bonusVersionList = {}
        bonusVersionList.year = this.bonusVersionList.year
        bonusVersionList.channelId = this.bonusVersionList.channel.split('^')[0]
        bonusVersionList.positionId = this.bonusVersionList.position.split('^')[0]
        this.getKpiList(bonusVersionList)
      }
    },
    // channel事件
    changeChannel (v) {
      // v--选中的值
      // console.log(v)
      this.bonusVersionList.position = null
      let channelId = v.split('^')[0]
      // 渠道筛选对应渠道职位
      this.channelFilterPosition(channelId)
      if (
        this.bonusVersionList.year !== null &&
        this.bonusVersionList.channel !== null &&
        this.bonusVersionList.position !== null
      ) {
        let bonusVersionList = {}
        bonusVersionList.year = this.bonusVersionList.year
        bonusVersionList.channelId = this.bonusVersionList.channel.split('^')[0]
        bonusVersionList.positionId = this.bonusVersionList.position.split('^')[0]
        this.getKpiList(bonusVersionList)
      }
    },
    // position事件
    changePosition (v) {
      // console.log(v)
      if (
        this.bonusVersionList.year !== null &&
        this.bonusVersionList.channel !== null &&
        this.bonusVersionList.position !== null
      ) {
        let bonusVersionList = {}
        bonusVersionList.year = this.bonusVersionList.year
        bonusVersionList.channelId = this.bonusVersionList.channel.split('^')[0]
        bonusVersionList.positionId = this.bonusVersionList.position.split('^')[0]
        this.getKpiList(bonusVersionList)
      }
    },
    // 渠道是否选择
    focusChannel (v) {
      // v--事件
      if (this.bonusVersionList.year === '' || this.bonusVersionList.year === null) {
        this.$message.warning('请选择年份！')
      }
    },
    // 渠道是否选择
    focusPosition (v) {
      // v--事件
      if (this.bonusVersionList.channel === '' || this.bonusVersionList.channel === null) {
        this.$message.warning('请选择渠道！')
      }
    },
    // 获取KPI配置列表--全部列表
    getKpiList (data) {
      this.$http.post(this.API.kpiOverviewList, data).then((res) => {
        let data = res.data
        if (data.code === 200) {
          let transfer = data.data
          if (transfer.length > 0) {
            // 有数据填充
            this.$refs.chooseKpiRef.selectedValueQ1 = this.selectedValue(
              transfer,
              'Q1',
              '季度考核'
            )
            this.$refs.chooseKpiRef.selectedValueQ2 = this.selectedValue(
              transfer,
              'Q2',
              '季度考核'
            )
            this.$refs.chooseKpiRef.selectedValueQ3 = this.selectedValue(
              transfer,
              'Q3',
              '季度考核'
            )
            this.$refs.chooseKpiRef.selectedValueQ4 = this.selectedValue(
              transfer,
              'Q4',
              '季度考核'
            )
            this.$refs.chooseKpiRef.selectedValueQ5 = this.selectedValue(
              transfer,
              'Yearly',
              '年度考核'
            )
            this.$refs.chooseKpiRef.selectedValueA1 = this.selectedValue(
              transfer,
              'Q1',
              '附加'
            )
            this.$refs.chooseKpiRef.selectedValueA2 = this.selectedValue(
              transfer,
              'Q2',
              '附加'
            )
            this.$refs.chooseKpiRef.selectedValueA3 = this.selectedValue(
              transfer,
              'Q3',
              '附加'
            )
            this.$refs.chooseKpiRef.selectedValueA4 = this.selectedValue(
              transfer,
              'Q4',
              '附加'
            )
            this.$refs.chooseKpiRef.selectedValueA5 = this.selectedValue(
              transfer,
              'Yearly',
              '附加'
            )
          } else {
            // 没数据清空
            this.$refs.chooseKpiRef.selectedValueQ1 = []
            this.$refs.chooseKpiRef.selectedValueQ2 = []
            this.$refs.chooseKpiRef.selectedValueQ3 = []
            this.$refs.chooseKpiRef.selectedValueQ4 = []
            this.$refs.chooseKpiRef.selectedValueQ5 = []
            this.$refs.chooseKpiRef.selectedValueA1 = []
            this.$refs.chooseKpiRef.selectedValueA2 = []
            this.$refs.chooseKpiRef.selectedValueA3 = []
            this.$refs.chooseKpiRef.selectedValueA4 = []
            this.$refs.chooseKpiRef.selectedValueA5 = []
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 获取选中KPI
    selectedValue (arr, quarter, kpiType) {
      let kpiData = []
      arr.forEach((ele) => {
        if (ele.quarter === quarter && ele.kpiType === kpiType) {
          kpiData.push(ele.kpi)
        }
      })
      return kpiData
    }
  }
}
</script>

<style lang="less" scoped>
.el-date-editor {
  width: 100% !important;
}
.el-form {
  width: 30%;
  min-width: 470px;
}
// 下拉选项宽度撑满
.el-select {
  width: 100% !important;
}
.el-row {
  margin-bottom: 10px;
}
</style>
